
import { Get, Post, Put, Delete } from "services";
import { ApiPath } from "paths";

export const searchSection = async (params) => {
  const res = await Post(`${ApiPath.SEARCH_SECTION}`, params);
  return res;
};

export const getSections = async ({ venueId, locationId }) => {
  const res = await Get(`${ApiPath.SECTION}`, { venueId, locationId });
  return res;
};

export const getSection = async ({ sectionId, ...body }) => {
  const res = await Get(`${ApiPath.SECTION_ID(sectionId)}`, body);
  return res;
};

export const createSection = async (body) => {
  const res = await Post(`${ApiPath.SECTION}?venueId=${body.venueId}&locationId=${body.locationId}`, body);
  return res;
};

export const editSection = async ({ sectionId, ...payload }) => {
  const res = await Put(`${ApiPath.SECTION_ID(sectionId)}?venueId=${payload.venueId}&locationId=${payload.locationId}`, payload);
  return res;
};

export const deleteSection = async ({ sectionId }) => {
  const res = await Delete(`${ApiPath.SECTION_ID(sectionId)}`);
  return res;
};